module.exports = __webpack_public_path__ + "img/myposition_cm.4563cb8a.svg";